<main class="survey-admin survey-create" role="main" aria-label="Create new survey">
  <header class="survey-admin__header">
    <h1 class="survey-admin__title">Create new survey</h1>
    <p class="survey-admin__desc">Give your survey a name. After creation you can add questions, answers, and prompts.</p>
  </header>

  <form class="survey-form survey-form--create" role="form" aria-labelledby="create-survey-heading" (ngSubmit)="submit()">
    <h2 id="create-survey-heading" class="sr-only">Survey name</h2>
    @if (errorMessage) {
      <p class="survey-form__error" role="alert">{{ errorMessage }}</p>
    }
    <div class="survey-form__group">
      <label class="survey-form__label" for="survey-name">
        Survey name <span class="survey-form__required" aria-hidden="true">*</span>
      </label>
      <input
        class="survey-form__input"
        type="text"
        id="survey-name"
        name="name"
        required
        maxlength="200"
        placeholder="e.g. Outsource Finance Scorecard"
        aria-required="true"
        autocomplete="off"
        [(ngModel)]="name"
      />
    </div>
    <div class="survey-form__actions">
      <button type="submit" class="btn btn-primary" [disabled]="submitting">
        {{ submitting ? 'Creating...' : 'Create survey' }}
      </button>
      <a class="btn survey-form__cancel" routerLink="/admin/survey-types">
        Cancel
      </a>
    </div>
  </form>
</main>
